angular.module('charts')
    .directive('dblProficiencyIndicator', function() {
        var statusToClass = {
            GROUP_PROFICIENT: 'indicator-completed',
            PROFICIENT: 'indicator-circle-proficient',
            IN_PROGRESS: 'indicator-circle-in-progress',
            NEEDS_ATTENTION: 'indicator-needs-attention',
            NOT_STARTED: 'indicator-circle-not-started'
        };

        return {
            restrict: 'E',
            scope: {
                dblProficiencyStatus: '=',
                dblShowLabel: '@'
            },
            controller: ['translateFilter', '$scope', function(translateFilter, $scope) {
              $scope.defaultStatus = 'NOT_STARTED';
              $scope.statusToLabel = {
                  GROUP_PROFICIENT: translateFilter('proficiencies.proficient'),
                  PROFICIENT: translateFilter('proficiencies.proficient'),
                  IN_PROGRESS: translateFilter('proficiencies.inProgress'),
                  NEEDS_ATTENTION: translateFilter('proficiencies.mayNeedAttention'),
                  NOT_STARTED: translateFilter('proficiencies.notStarted')
              };
            }],
            templateUrl: '/resources/charts/directives/proficiency-indicator/dbl-proficiency-indicator.directive.html',
            link: function(scope, element) {
                scope.$watch('dblProficiencyStatus', function (newVal) {
                    var indicatorClass = statusToClass[scope.dblProficiencyStatus];
                    scope.indicatorClass = indicatorClass ? indicatorClass : statusToClass[scope.defaultStatus];

                    var label = scope.statusToLabel[scope.dblProficiencyStatus];
                    scope.label = label ? label : scope.statusToLabel[scope.defaultStatus];
                });
            }
        };
    });
